import { render, staticRenderFns } from "./GridVideo.vue?vue&type=template&id=3864881c&scoped=true&"
import script from "./GridVideo.vue?vue&type=script&lang=js&"
export * from "./GridVideo.vue?vue&type=script&lang=js&"
import style0 from "./GridVideo.vue?vue&type=style&index=0&id=3864881c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3864881c",
  null
  
)

export default component.exports